import { FC } from 'react'

import { useViewportBreakpoints } from '@syconium/little-miss-figgy'

import { SlideItemProps } from '../constants'
import Iphone from '../Iphone'
import {
  BottomDownloadSection,
  BottomDownloadTitle,
  MobileViewItem,
  MobileViewWrapper,
} from '../MobileView/MobileView.style'
import { ItemSubTitle, ItemTitle } from '../SlideItem/SlideItem.style'
import { ImageWrapper, PopUpWrapper, StoreBtnWrapper } from '../style'

import StoreBtn from './StoreBtn'

interface MobileViewProps {
  slideItems: SlideItemProps[]
}

const MobileView: FC<MobileViewProps> = ({ slideItems }) => {
  const viewport = useViewportBreakpoints()

  return (
    <MobileViewWrapper>
      {slideItems.map(({ image, title, subTitle, popper }, index) => (
        <MobileViewItem key={index} background={!(index % 2) ? '#F3F3F3' : 'transparent'}>
          <ImageWrapper>
            <Iphone background={image} index={index} />
            {popper && (popper?.viewport === viewport || !popper.viewport) && (
              <PopUpWrapper
                src={popper.image}
                alt={title}
                maxWidth={popper.maxWidth}
                bottom={popper.bottom}
                top={popper.top}
                width={popper.width}
                left={popper.left}
                right={popper.right}
              />
            )}
          </ImageWrapper>
          <ItemTitle>{title}</ItemTitle>
          <ItemSubTitle>{subTitle}</ItemSubTitle>
        </MobileViewItem>
      ))}
      <BottomDownloadSection>
        <BottomDownloadTitle>DOWNLOAD NOW</BottomDownloadTitle>
        <StoreBtnWrapper>
          <StoreBtn />
        </StoreBtnWrapper>
      </BottomDownloadSection>
    </MobileViewWrapper>
  )
}

export default MobileView
